document.addEventListener("DOMContentLoaded",function(){var buyNowButton=document.getElementById("BuyNowButton");buyNowButton&&buyNowButton.addEventListener("click",function(){window.location.href="/checkout"})});
//# sourceMappingURL=/s/files/1/0692/7679/5126/t/6/assets/custom.js.map?v=1723773805
